import { toast } from './toast.js';

export function openShareModal() {
  document.getElementById('shareModal').classList.add('show');
}

export function closeModal() {
  document.querySelectorAll('.modal-bg').forEach(m => m.classList.remove('show'));
}

export function copyShareLink() {
  const url = document.getElementById('shareUrl').value;
  navigator.clipboard.writeText(url);
  toast('Link copied');
  closeModal();
}
